export class AviationEventFilter {

  name = '';

  startDate = new Date();

  endDate = new Date(new Date().setMonth(new Date().getMonth() + 6));

  airshow = true;

  airshowwithmilitarydemonstrationteam = true;

  flyin = true;

  flyout = true;

  pancakeBreakfast = true;

  socialGathering = true;

  openhouse = true;

  pokerRun = true;

  aviationCommunityDay = true;

  wingsAndWheels = true;

  aircraftDisplayRides = true;

  aopaRustyPilots = true;

  aopaFlyingClub = true;

  safetySeminar = true;

  conference = true;

  workshop = true;

  aopaBacktoYourRoots = true;

  formatInPerson = true;

  formatOnline = true;

  international = false;
}
